module.exports = __webpack_public_path__ + "static/media/pin-secondary-privado.4b3eb9db.png";